// This file contains the user type constants used in the application.
export const USER_TYPE = {
	GUEST: 1,
	INTERN: 3,
	EXTERNAL: 4,
	CONTRACTOR: 5,
	CLEANER: 6,
	UNKNOWN: 7,
	ZEZAMII_USER: 8,
	ACCESS_ONLY_USER: 9,
	VISITOR: 10
};

// Types with no Zezamii login. Mirrors the App Server's PERSON.ACCESS_ONLY_TYPES (the boundary for
// /people/accessOnly) — keep the two in step.
export const NO_LOGIN_USER_TYPES = [USER_TYPE.GUEST, USER_TYPE.ACCESS_ONLY_USER, USER_TYPE.VISITOR];

// Platform staff: may hold roles and join teams. Type 9 stays until its migration to type 8 lands.
export const STAFF_USER_TYPES = [USER_TYPE.ZEZAMII_USER, USER_TYPE.ACCESS_ONLY_USER];

// Can this person type hold a login at all? Whether one exists is hasLogin(person) in personStatus.
export const canHoldLogin = (userTypeID) => !NO_LOGIN_USER_TYPES.includes(userTypeID);
